package org.koin.ksp.generated

import org.koin.core.module.Module
import org.koin.dsl.*


public val com_essntl_features_proposal_domain_di_ProposalUseCaseModule : Module get() = module {
	single() { _ -> com.essntl.features.proposal.domain.use_case.UpdateProposalServiceUseCase(proposalRepository=get(),toastManager=get()) } 
}
public val com.essntl.features.proposal.domain.di.ProposalUseCaseModule.module : org.koin.core.module.Module get() = com_essntl_features_proposal_domain_di_ProposalUseCaseModule
